<template>
  <div class="pd-embed-control" :class="{'pd-embed-contorl-disabled':!editable}">
    <template v-if="editable">
      <div class="flex-wrap pd-embed-value" style="padding:0 8px;cursor:pointer;" @click="modalSelector=true">
        {{value?value.length+'个签名 (点击编辑)':'点击配置'}}
      </div>
    </template>
    <template v-else>
      {{value?value.length+'个签名 (点击编辑)':'点击配置'}}
    </template>

    <Modal v-model="modalSelector" footer-hide title="新增签名" :width="400">
      <div>
        <BaseFlexTable v-model="items" :columns="cols" @input="$emit('input',items)" :ordered="false" />
      </div>
    </Modal>
  </div>
</template>

<script>
import {cloneDeep} from 'lodash';

export default {
  data() {
    return {
      items: [],
      modalSelector: false,
    };
  },
  watch: {
    value: {
      handler(v) {
        if (Array.isArray(v)) {
          this.items = cloneDeep(v);
        } else {
          this.items = [{}];
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    opt() {
      return this.option || {};
    },
    cols() {
      return [{
        name: '序',
        key: 'index',
        control: 'index',
        span: 3,
      }, {
        name: '拖',
        key: 'drag',
        control: 'drag',
        span: 3,
      }, {
        key: 'identify',
        control: 'AutoComplete',
        span: 12,
        option: {
          transfer: true,
          data: ['总监', '监理员'],
        },
        name: '岗位身份',
      }];
    },
  },
  props: ['value', 'editable', 'option'],
};
</script>

<style>

</style>
